const urlReport = () => 
{
    const urlBase = process.env.NODE_ENV == "development" ? "http://reportsclinicavalle.eurekani.com" : "http://reportsclinicavalle.eurekani.com";

    return {
        billTicket : id => `${urlBase}/bills?id=${id}`,
        cotizacion : id => `${urlBase}/bills/cotizacion?id=${id}`,
        card : id => `${urlBase}/records?id=${id}`,
        receiptTicket : id => `${urlBase}/receivables?id=${id}`,
        
        clients : `${urlBase}/clients`,
        clientsMora : `${urlBase}/clients/receivables`,
        clientsPorEdad: queryString => `${urlBase}/clients/PorEdad?${queryString}`,

        records: (from, to, clientId) => `${urlBase}/records/list?from=${from}&to=${to}&clientId=${clientId}`,

        bills: queryString => `${urlBase}/bills/BySeasion?${queryString}`,
        sales: date => `${urlBase}/bills/Sales?date=${date}`,
        items: (from, to) => `${urlBase}/bills/items?from=${from}&to=${to}`,
        itemsCodeBar: id => `${urlBase}/items/codebar?id=${id}`,
        inventario: typeId => `${urlBase}/bills/inventario?typeId=${typeId}`,
        proveedores: `${urlBase}/bills/proveedores`,
        valoracion: `${urlBase}/items/ValorAlmacen`,
        compras: `${urlBase}/providers/compras`,

        print : url =>  window.open(`${url}`,'_blank')
    }

}

export default urlReport;